/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Typography } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { BackButton } from "../components/BackButton";
import ContactCard from "../components/ContactCard";
import { PageContainer } from "../components/layout/PageContainer";
import YesNoAction from "../components/YesNoAction";
import {
  selectContactInfo,
  selectCurrentFarmerAccount,
  selectUserContactDetails,
} from "../features/azure-b2c/storage";
import { TestIds } from "../testIds";

export const SeedOrderSuccess = () => {
  const userDetails = useSelector(selectUserContactDetails);
  const currentAccount = useSelector(selectCurrentFarmerAccount);
  const navigate = useNavigate();

  const relationshipOwner = useSelector(selectContactInfo);

  const cartOrMessage = React.useMemo(() => {
    return (
      <>
        <YesNoAction
          display="Seed order sent"
          subheading={
            <Typography variant="h4" sx={{ mt: 4, mb: 2 }}>
              Thanks {userDetails?.firstName}!
            </Typography>
          }
          body={
            <Typography variant="body2">
              Your seed order has been sent to Farmlands for fulfilment.
            </Typography>
          }
        />
        <ContactCard
          sx={{ mt: 4 }}
          title="If you have any questions please contact your Farmlands representative."
          data-testid={TestIds.components.contactCard.card}
          {...relationshipOwner}
        />
      </>
    );
  }, [currentAccount]);

  return (
    <PageContainer data-testid={TestIds.pages.seedOrderSuccess}>
      <BackButton text="Home" onClick={() => navigate("/")} />
      {cartOrMessage}
    </PageContainer>
  );
};
